import { ChevronDown, CheckCircle2, Clock, Landmark } from 'lucide-react';

export default function PayoutHistory({ 
  selectedFilter, 
  setSelectedFilter, 
  selectedYear, 
  setSelectedYear, 
  payoutHistory 
}) {
  const getStatusIcon = (status) => {
    return status === 'Completed' ? <CheckCircle2 size={16} className="text-emerald-600" /> : <Clock size={16} className="text-amber-600" />;
  };

  const getStatusColor = (status) => {
    return status === 'Completed' 
      ? 'text-emerald-700 bg-emerald-50 border-emerald-200' 
      : 'text-amber-700 bg-amber-50 border-amber-200';
  };

  return (
    <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Payout History</h2>
      </div>

      {/* Filter Options */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2">
          <button
            onClick={() => setSelectedFilter('all')}
            className={`px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${
              selectedFilter === 'all'
                ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
                : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setSelectedFilter('deposits')}
            className={`px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${
              selectedFilter === 'deposits'
                ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
                : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
            }`}
          >
            Reward Deposits
          </button>
          <button
            onClick={() => setSelectedFilter('transfers')}
            className={`px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${
              selectedFilter === 'transfers'
                ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
                : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
            }`}
          >
            Reward Transfers
          </button>
        </div>

        {/* Year Selector */}
        <div className="relative">
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="px-3 py-2 pr-8 text-sm bg-white rounded-lg border border-gray-200 appearance-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          >
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
          </select>
          <ChevronDown className="absolute right-2 top-1/2 w-4 h-4 text-gray-400 transform -translate-y-1/2 pointer-events-none" />
        </div>
      </div>

      {/* Payout History Table */}
      <div className="space-y-3">
        {payoutHistory.length > 0 ? (
          payoutHistory.map((payout) => (
            <div key={payout.id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-3">
                {getStatusIcon(payout.status)}
                <div>
                  <p className="text-sm font-medium text-gray-900">{payout.type}</p>
                  <p className="text-xs text-gray-500">{payout.date}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">{payout.amount}</p>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(payout.status)}`}>
                  {payout.status}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="py-8 text-center">
            <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gray-100 rounded-full">
              <Landmark className="w-8 h-8 text-gray-400" />
            </div>
            <p className="text-sm text-gray-500">No payout history available</p>
            <p className="mt-1 text-xs text-gray-400">Your payout history will appear here once you start earning commissions</p>
          </div>
        )}
      </div>
    </div>
  );
}
